<template>
  <el-dialog :visible.sync="showDialog" :close-on-click-modal="false" :close-on-press-escape="false">
    <div class="card-wraper">
      <div class="box-card">
        <div slot="header" class="card-header">
          <span>{{ stackData.defineName }}</span>
          <span v-if="isView">{{ stackData.row }} * {{ stackData.column }}</span>
        </div>
        <div>
          <div v-if="!isView" class="card-shortcut">
            <div class="shortcut-title">堆箱规格:</div>
            <div>
              <el-input v-model.number="stackData.row"  size="mini" placeholder="行" style="width:50px" @blur="checkIsNumber(stackData.row,'row')" />
              <span style="padding: 0 5px">*</span>
              <el-input v-model.number="stackData.column" size="mini" placeholder="列" style="width:50px" @blur="checkIsNumber(stackData.column,'column')" />
            </div>
            <div class="shortcut-title">单堆快捷设置:</div>
            <el-select
              class="shortcut-main"
              v-model="shortcutBrand"
              placeholder="选择子品牌"
              size="mini"
              filterable
              clearable
              @change="setAllBrandWithShortcut()"
            >
              <template v-for="item in subBrandOptions">
                <el-option
                  :key="item.abiBrandId"
                  :label="item.abiBrandName"
                  :value="`${item.abiBrandCode},${item.brandName},${item.tradeStackColor}`"
                ></el-option>
              </template>
            </el-select>
          </div>
          <hr>
          </div>
        <div class="card-select">
          <div class="card-box" v-for="(column, index) in stackData.column" :key="index">
            <el-select
              v-if="!isView"
              v-model="brandSelected[index]"
              placeholder="选择子品牌"
              size="mini"
              filterable
              :style="{paddingRight: (column < stackData.column ? '5px' : '0px')}"
            >
              <template v-for="item in subBrandOptions">
                <el-option
                  :key="item.abiBrandId"
                  :label="item.abiBrandName"
                  :value="`${item.abiBrandCode},${item.brandName},${item.tradeStackColor}`"
                />
              </template>
            </el-select>
            <div
              class="card-item"
              :style="{ backgroundColor: brandSelected[index] ? getBrandInfo('color', index) : '#fff' }"
              v-for="row in stackData.row"
              :key="row"
            >
              {{ brandSelected[index] ? getBrandInfo("name", index) : "" }}
            </div>
          </div>
        </div>
        <div class="card-operte">
          <el-button type="primary" @click="close">关闭</el-button>
          <el-button v-if="!isView" type="danger" @click="confirmDesign()">确定生成</el-button>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'PerfectStackConfigDialog',
  props: {
    subBrandOptions: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data () {
    return {
      options: {
        indexSelected: null,
        showMode: 'edit'
      },
      showDialog: false,
      stackData: {
        defineName: '',
        row: null,
        column: null,
        brandList: []
      },
      brandSelected: [],
      shortcutBrand: ''
    }
  },
  computed: {
    isView () {
      return this.options.showMode !== 'edit'
    }
  },
  methods: {
    show (data, options) {
      this.stackData = Object.assign({}, data.stackData)
      this.brandSelected = data.brandSelected || []
      this.options = Object.assign({}, options)
      this.showDialog = true
      this.shortcutBrand = ''
    },
    close () {
      this.showDialog = false
    },
    // 行列为整数
    checkIsNumber (value, type) {
      let index = value
      let deleteNumber = this.brandSelected.length - value
      // console.log(index, deleteNumber, type)
      if (type === 'column') {
        this.brandSelected.splice(index, deleteNumber)
      }
      if (value !== parseInt(value) || value <= 0) {
        this.$message.warning('请输入大于0的整数')
        if (type === 'row') {
          this.stackData.row = ''
        }
        if (type === 'column') {
          this.stackData.column = ''
        }
      }
    },
    setAllBrandWithShortcut () {
      this.brandSelected = []
      for (let i = 0; i < this.stackData.column; i++) {
        this.brandSelected.push(this.shortcutBrand)
      }
    },
    getBrandDesc (val) {
      if (val) {
        let list = val.split(',')
        return list[1]
      }
    },
    getBrandInfo (type, index) {
      if (!this.brandSelected.length) return
      if (type === 'color') {
        return this.brandSelected[index].split(',')[2]
      }
      if (type === 'name') {
        return this.brandSelected[index].split(',')[1]
      }
    },
    confirmDesign () {
      if (!this.checkUnfinished()) {
        return
      }
      const payload = {
        stackData: this.stackData,
        brandSelected: this.brandSelected,
        options: this.options
      }
      this.$emit('confirm', payload)
    },
    // 校验为空
    checkUnfinished () {
      if (!this.stackData.row) {
        this.$message.warning('请设定堆箱行数')
        return false
      }
      if (!this.stackData.column) {
        this.$message.warning('请设定堆箱列数')
        return false
      }
      for (let i = 0; i < this.brandSelected.length; i++) {
        if (!this.brandSelected[i]) {
          this.$message.warning('第' + i + '列未选择品牌')
          return false
        }
      }
      if (this.brandSelected.length < this.stackData.column) {
        this.$message.warning('请正确选择所有品牌')
        return false
      }
      return true
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-dialog{
  min-width: 850px
}
.card-wraper {
  // position: absolute;
  width: 100%;
  height: calc(100% + 120px);
  top: -60px;
  right: 0;
  left: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2;
}
.box-card {
  // width: 700px;
  pointer-events: auto;
  z-index: 2;
  .card-header {
    text-align: center;
    line-height: 40px;
    font-size: 18px;
    font-weight: 600;
    color: #333;
    span {
      display: inline-block;
      width: 50%;
    }
  }
  .card-shortcut {
    display: flex;
    align-items: center;
    .shortcut-title {
      width: 110px;
      margin: 20px 10px 20px 20px;
    }
  }
  .card-select {
    display: flex;
    flex-wrap: nowrap;
    overflow-x: scroll;
    max-height: 500px;
    max-width: 700px;
    padding-bottom: 20px;
    margin-top: 20px;
    min-width: 350px;
  }
  .card-box {
    margin: auto;
  }
}
.card-item {
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  width: 80px;
  height: 55px;
  margin: 10px auto 0;
  line-height: initial;
  text-align: center;
  color: #fff;
  border: 1px solid #c0c4cc;
  border-radius: 10px;
}
.card-operte {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 20px;
}
::v-deep .el-dialog__header {
  border: none!important;
  padding:none!important;
}
</style>
